import { CoreRankingsTable } from '../../../views';
import { RankingsRowStreak } from '../RankingsRow';
import Radio from 'backbone.radio';
import { RankingsEmptyRow } from '../../../../../core/views/Rankings/RankingsEmptyRow';

const rankingsChannel = Radio.channel( 'Rankings' );
const start_round_streak = process.env.START_ROUND_STREAK;

/**
 * @desc Rankings Table Streak Class
 * This class using on rankings page ('rankings/streak')
 */
export class RankingsTableStreak extends CoreRankingsTable {
	get className() {
		return 'team-rankings league-table shadow';
	}

	get childView() {
		return RankingsRowStreak;
	}

	get emptyView() {
		let actual_round = this.rounds.actual;

		if( actual_round ) {
			if(
				actual_round.get('id') < start_round_streak
			) {
				return false;
			}
			else {
				return RankingsEmptyRow;
			}
		}
	}

	fetchData() {
		return Promise.all( [
			this.collection
				.showStreakRankings(),
			this.rounds.fetch()
		] );
	}

	updateModel() {
		let rounds = this.rounds.recalculateCompleteRounds( false );
		this.model.set( {
			rounds
		} );

		rankingsChannel.trigger( 'rankings:model:updated' );

		return this;
	}
}

export default RankingsTableStreak;